var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Tab as MuiTab, Tabs as MuiTabs } from '@mui/material';
import { getAttributes, alterResponsiveValues } from '../../../utils';
import { TabsThemes, TabsScrollButtonsProps } from './types';
import { Text, TextVariants, TextHtmlTags, TextThemes, TextHorizontalAlignments as TabsHorizontalAlignments } from '../../atoms/text';
import { IconButton, IconButtonSize, IconButtonStyles, IconButtonRole } from '../../atoms/icon-button';
import { Container, ContainerDisplays } from '../../templates/container';
var ScrollArrowButton = function (scrollButtonprops, theme) {
    var direction = scrollButtonprops.direction, disabled = scrollButtonprops.disabled, onClick = scrollButtonprops.onClick;
    var configScrollIconButtons = {
        background: 'transparent',
        size: IconButtonSize.Small,
        style: theme === TabsThemes.Dark
            ? IconButtonStyles.BasicDark
            : IconButtonStyles.Basic,
        role: IconButtonRole.Button,
        className: [
            theme === TabsThemes.Dark
                ? "".concat(TabsThemes.Light.toString().toLowerCase(), "-special")
                : "".concat(TabsThemes.Dark.toString().toLowerCase(), "-special")
        ].join(' ')
    };
    var configScrollIconButtonLeft = {
        icon: 'pmi-icon-chevronleft',
        'aria-label': 'pmi-icon-chevronleft'
    };
    var configScrollIconButtonRight = {
        icon: 'pmi-icon-chevronright',
        'aria-label': 'pmi-icon-chevronright'
    };
    if (direction === 'left' && !disabled) {
        return (React.createElement(IconButton, __assign({ onClick: function (e) {
                return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            } }, configScrollIconButtons, configScrollIconButtonLeft)));
    }
    if (direction === 'right' && !disabled) {
        return (React.createElement(IconButton, __assign({ onClick: function (e) {
                return onClick === null || onClick === void 0 ? void 0 : onClick(e);
            } }, configScrollIconButtons, configScrollIconButtonRight)));
    }
    return null;
};
var T = function (_a) {
    var props = __rest(_a, []);
    var centered = props.centered, tabsVariant = props.tabsVariant, tabLabels = props.tabLabels, value = props.value, onChange = props.onChange, _b = props.scrollButtons, scrollButtons = _b === void 0 ? TabsScrollButtonsProps.Auto : _b, tabsTheme = props.tabsTheme, _c = props.horizontalAlignment, horizontalAlignment = _c === void 0 ? TabsHorizontalAlignments.Start : _c, rest = __rest(props, ["centered", "tabsVariant", "tabLabels", "value", "onChange", "scrollButtons", "tabsTheme", "horizontalAlignment"]);
    var muiConfigTabs = __assign(__assign(__assign({}, (scrollButtons && {
        ScrollButtonComponent: function (propsScroll) {
            return ScrollArrowButton(propsScroll, tabsTheme || TabsThemes.Light);
        }
    })), { 
        // not working with scrollable (investigate)
        centered: centered, variant: tabsVariant, value: value, onChange: onChange, scrollButtons: scrollButtons, className: [tabsTheme === TabsThemes.Dark && TabsThemes.Dark]
            .filter(Boolean)
            .join(' ') }), getAttributes(rest));
    var muiConfigTab = {
        disableRipple: true
    };
    var muiConfigTabLabel = __assign({ variant: TextVariants.Body1, component: TextHtmlTags.Span }, (tabsTheme === TabsThemes.Dark && { textTheme: TextThemes.Dark }));
    var wrapperConfig = __assign({ display: ContainerDisplays.Flex }, (horizontalAlignment
        ? {
            flexJustifyContent: alterResponsiveValues(horizontalAlignment, function (align) { return align.toLowerCase(); })
        }
        : null));
    return (
    // workaround
    React.createElement(Container, __assign({}, wrapperConfig),
        React.createElement(MuiTabs, __assign({}, muiConfigTabs), tabLabels &&
            tabLabels.length > 0 &&
            tabLabels.map(function (label, i) { return (React.createElement(MuiTab, __assign({}, muiConfigTab, { key: i, label: React.createElement(Text, __assign({}, muiConfigTabLabel, { content: label })) }))); }))));
};
export { T as Tabs };
